export default __webpack_public_path__ + "static/media/chrono.0528b26e.mp3";